import { render } from "./StandbyFeedback.vue?vue&type=template&id=4f71d38c&ts=true"
import script from "./StandbyFeedback.vue?vue&type=script&lang=ts"
export * from "./StandbyFeedback.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__